import { LandingPage as LandingPageType } from "graphql/generated-types";
import PageInner from "@/layouts/PageInner";
import BlockRouter, { BlockTypes } from "@/components/blocks/BlockRouter";
import Hero from "@/components/Hero";

export default function LandingPage({ data }: { data: LandingPageType }) {
	return (
		<>
			<Hero page={data} />
			<PageInner>
				<BlockRouter blocks={data.body as [BlockTypes]} />
			</PageInner>
		</>
	);
}
